/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestService } from '../../RestService';

class SiteService extends RestService {
    /** @ngInject */
    constructor($q, resource, $httpParamSerializerJQLike, $log) {
        super($q, resource,  $httpParamSerializerJQLike, $log, false);
        $log.debug('Service \'SiteService\' loaded');
    }
}

export { SiteService };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/organization/service/SiteService.js